export const Routes = {
  Applications: {
    path: "/applications",
  },
  Policies: {
    path: "/policies",
    createPath: "/policies/create",
    editPath: "/policies/edit/:id?",
  },
  UserGuide: {
    path: "/user-guide",
  },
  ApplicationDetails: {
    path: "/applications/:applicationUniqueName/:tabName?",
  },
  Users: {
    usersList: {
      path: "/users",
    },
    user: {
      path: "/view/:id/:tabName?/:systemResourceType?/:subTabName?",
    },
  },
  NotFound: {
    path: "/not-found",
  },
  Forbidden: {
    path: "/forbidden",
  },
  UserGroups: {
    path: "/user-groups/:userGroupTypeUniqueName/:userGroupUniqueName?/:tabName?/:systemResourceType?/:subTabName?",
    basePath: "/user-groups",
    keyCondition:
      "/user-groups/:userGroupTypeUniqueName/:userGroupUniqueName/key-condition/:action/:conditionId?",
    previewCondition:
      "/user-groups/:userGroupTypeUniqueName/:userGroupUniqueName/key-condition/preview/:conditionId",
  },
  InformationAssets: {
    path: "/information-assets",
  },
  InformationAssetDetails: {
    path: "/information-assets/:assetId/:activeTab?",
  },
  SystemUserGroupDetails: {
    path: "/information-assets/:assetId/:systemId/user-group/:groupId/",
  },
};
